import React from "react";
import './SubjectHeaderRow.css';

const FILTER_TABS = [
  { label: 'All', value: 'all' },
  { label: 'Warm-up', value: 'foundation' },
  { label: 'Core', value: 'curriculum' },
  { label: 'Boost', value: 'advanced' },
];

const SubjectHeaderRow = ({
  activeSubject,
  isSideQuestDisabled,
  activeColor = '#4f46e5',
  completedCount = 0,
  activeFilter = 'curriculum', // 'all' | 'foundation' | 'curriculum' | 'advanced'
  onFilterChange        // Callback receiving (filterValue)
}) => {
  const handleSelectFilter = (filterValue) => {
    if (onFilterChange) {
      onFilterChange(filterValue);
    }
  };

  return (
    <div className="active-subject-meta-row">
      <div className="subject-header-top-row">
        {/* Left Side: Subject Details */}
        <div className="subject-heading-block">
          <div
            className="subject-avatar-badge"
            style={{ backgroundColor: isSideQuestDisabled ? '#94a3b8' : activeColor }}
          >
            {activeSubject?.name?.charAt(0) || 'S'}
          </div>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <h2>{activeSubject?.name}</h2>
              {isSideQuestDisabled && (
                <span className="locked-pill-badge">🔒 Locked</span>
              )}
            </div>
            <p className="mastery-tracker-text">
              {isSideQuestDisabled ? (
                <span>Complete regular quizzes to unlock Side Quests!</span>
              ) : (
                <>
                  Mastery Level: <strong>{completedCount}</strong> of{" "}
                  <strong>{activeSubject?.Topics?.length || 0}</strong> completed units.
                </>
              )}
            </p>
          </div>
        </div>

        {/* Right Side: Topic Category Filter Pills */}
        {!isSideQuestDisabled && (
          <div className="subject-filter-group" role="tablist" aria-label="Filter topics by type">
            {FILTER_TABS.map((tab) => {
              const isActive = activeFilter === tab.value;
              return (
                <button
                  key={tab.value}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  className={`filter-pill-btn ${isActive ? 'filter-pill-btn--active' : ''}`}
                  style={{
                    '--subject-color': activeColor,
                    ...(isActive ? { backgroundColor: activeColor } : {})
                  }}
                  onClick={() => handleSelectFilter(tab.value)}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
        )}
      </div>

      {/* Bottom Glow Line */}
      <div
        className="accent-glow-line"
        style={{ backgroundColor: isSideQuestDisabled ? '#cbd5e1' : activeColor }}
      ></div>
    </div>
  );
};

export default SubjectHeaderRow;